<template>
  <div class="user">
    <div>
      <h2>{{ user.username }}</h2>
      <p>{{ user.playlists.length }} album list<span v-if="user.playlists.length != 1">s</span></p>
    </div>

    <div id="lists">
      <div class="list" v-for="list in user.playlists" v-bind:key="list.id">
        <list-index-entry :list="list"></list-index-entry>
      </div>
    </div>
  </div>
</template>

<script>
import UsersService from '@/services/UsersService'
import ListIndexEntry from '@/components/ListIndexEntry'
export default {
  name: 'user',
  components: {
    ListIndexEntry
  },
  watch: {
    $route (to, from) {
      this.getUser()
    }
  },
  data () {
    return {
      user: {playlists: []}
    }
  },
  mounted () {
    this.getUser()
  },
  methods: {
    getUser () {
      UsersService.fetchUser(this.$route.params.username)
        .then((response) => {
          this.user = response.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User.vue